import { useEffect, useMemo } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import HotBoard from "./components/HotBoard";
import Channels from "./components/Channels";
import Feed from "./components/Feed";
import About from "./components/About";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BackTop from "./components/BackTop";
import JsonLd from "./components/JsonLd";

export default function Home() {
  const url = useMemo(
    () => `${window.location.origin}${window.location.pathname}`,
    [],
  );

  useEffect(() => {
    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = url;
    document.title =
      "每日爆料网｜热点线索征集·消费维权·民生曝光投稿平台";
  }, [url]);

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "每日爆料网",
    url,
    description: "面向全网征集热点线索与曝光素材的议题跟进平台",
    email: "liuyan@meiribaoliao.example",
    contactPoint: {
      "@type": "ContactPoint",
      email: "liuyan@meiribaoliao.example",
      contactType: "customer service",
    },
  };

  const webSiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "每日爆料网",
    url,
    inLanguage: "zh-CN",
    description:
      "每日爆料网面向全网征集热点线索与曝光素材，覆盖消费维权、民生关注、职场真相、食品安全等栏目，设有线索曝光台与私信投稿通道。",
  };

  return (
    <>
      <JsonLd data={orgSchema} />
      <JsonLd data={webSiteSchema} />
      <Header />
      <main>
        <Hero />
        <HotBoard />
        <Channels />
        <Feed />
        <About />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <BackTop />
    </>
  );
}